/**
 * Оплаченный доступ к заданию, прочитанный мимо кэша RTK Query.
 *
 * Контракт: `product.is_acquired` — единственный признак, по которому фронт решает,
 * пускать ли участника в платный экзамен. После оплаты кэш этого признака устаревает
 * (событие OrderCompleted приходит не всегда — см. usePostPaymentRefresh), поэтому
 * перед повторным походом в корзину доступ перечитывается здесь.
 *
 * Бэкенд не ответил — считаем, что доступа нет: участник идёт к оплате, как и раньше.
 */
import { assignmentApi } from "@/api/assignment/assignmentApi";
import { purchaseCompleted } from "@/store/slices/basketSlice";
import type { AppDispatch } from "@/store";

export async function fetchPrepaidAccess(
  dispatch: AppDispatch,
  assignmentId: number,
): Promise<boolean> {
  const request = dispatch(
    assignmentApi.endpoints.getAssignmentAsStudent.initiate(
      { assignmentId, role: "student" },
      { forceRefetch: true },
    ),
  );

  try {
    const fresh = await request.unwrap();
    return Boolean(fresh?.product?.is_acquired);
  } catch {
    return false;
  } finally {
    /* Без отписки запрос остаётся в кэше «живым» и тянет за собой рефетчи. */
    request.unsubscribe();
  }
}

/**
 * Доступ появился — то же, что делает корзина по событию OrderCompleted.
 *
 * Сбросить один счётчик purchaseToken мало: список заданий откатывается на первую
 * страницу, а RTK Query отдаёт её из кэша (refetchOnMountOrArgChange выключен), и
 * замок остаётся на строке. Поэтому теги гасятся первыми — как в BasketModal.
 */
export function markPrepaidAccessGranted(dispatch: AppDispatch): void {
  dispatch(assignmentApi.util.invalidateTags(["AssignmentsList", "AssignmentDetail"]));
  dispatch(purchaseCompleted());
}
